import React, { useEffect, useState } from "react";
import {
  Dialog,
  Typography,
  Box,
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import useSystem from "../../hooks/useSystem";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Avatar from "@mui/material/Avatar";
import DraggableContent from "../DraggableContent";
import { getUsersRequest } from "api/users";
import { useRcState } from "WebR/system/Provider";
import useStyles from "./style-jss";
import { useNavigate } from "react-router-dom";
import { getMemberInfoRequest } from "api/memberInformation";

const CallPending = () => {
  const { data, answer, ToVoiceMail, Forward, setCallData } = useSystem();
  const [memberInfo, setMemberInfo] = useState(null);
  const classes = useStyles();
  const navigate = useNavigate();
  const { callService } = useRcState();
  const [initials, setInitials] = React.useState("UN");
  const [initialsNum, setInitialsNum] = React.useState("");
  const [forwardas, setforwardas] = React.useState("");
  const [state, _setState] = React.useState({
    contacts: [],
    loading: true,
  });

  const setState = (values) => _setState({ ...state, ...values });

  const handleClick = () => {
    answer();
    memberInfo.id
      ? navigate(`/app/members/${memberInfo.id}`)
      : navigate(`/app/members`);
  };

  useEffect(() => {
    getUsersRequest().then((res) => {
      setState({
        contacts: res.data.response.result,
        loading: false,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchMemberInfo(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.phoneNo]);

  const fetchMemberInfo = async (data) => {
    try {
      const response = await getMemberInfoRequest({ phone_no: data.phoneNo });
      setMemberInfo(response.data);
    } catch (error) {
      console.error("Failed to fetch member info:", error);
    }
  };
  const calculateInitials = (name) => {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");
    let initials = [...name.matchAll(rgx)] || [];
    return (
      (initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
    ).toUpperCase();
  };

  useEffect(() => {
    if (
      typeof data === "object" &&
      data.contact &&
      typeof data.contact === "string" &&
      data.contact.trim() !== ""
    ) {
      const initialsal = calculateInitials(data.contact);
      setInitials(initialsal);
      setInitialsNum(data.contact);
    } else {
      setInitialsNum(data.phoneNo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.contact, data.state]);

  const handleAman = (event) => {
    setforwardas(event.target.value);
  };

  const handlefor = () => {
    Forward(forwardas);
  };

  if (data.toForward === true) {
    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={data.toForward}
        fullWidth={true}
        maxWidth="sm"
      >
        <IconButton
          aria-label="close"
          onClick={() => setCallData({ toForward: false })}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container spacing={2} direction="row" alignItems="center">
          <Grid
            item
            xs={5}
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Avatar
              sx={{
                mt: 3,
                ml: 6,
                bgcolor: "#0B557B",
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                border: "10px solid #D2E2EA",
                boxShadow: "0 0 0px 10px #EAF8FF",
              }}
            >
              {initials}
            </Avatar>
            <Typography sx={{ mt: 2, ml: 7, mb: 2, fontSize: "20px" }}>
              {initialsNum}
            </Typography>
          </Grid>
          <Grid item xs={7} direction="column" justifyContent="center">
            <Box sx={{ flexDirection: "row" }}>
              <Box>
                <Typography sx={{ fontSize: "26px", color: "#346077" }}>
                  Incoming Call{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#515151",
                    fontWeight: 600,
                    lineHeight: "normal",
                  }}
                >
                  Status:{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "#5B5B5B",
                      fontWeight: 400,
                      lineHeight: "normal",
                    }}
                  >
                    Connecting...
                  </span>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ mt: "16px" }}>
              <InputLabel
                htmlFor="outlined-adornment-password"
                sx={{ fontWeight: "bold" }}
              >
                Select Name
              </InputLabel>
              <FormControl
                variant="outlined"
                size="small"
                sx={{ mr: 2, minWidth: 200 }}
              >
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={forwardas}
                  // label="Select Name"
                  onChange={handleAman}
                >
                  {!state.loading &&
                    state.contacts.length > 0 &&
                    state.contacts.map(
                      (item) =>
                        callService.user.extension !== item.extension &&
                        item.extension !== undefined &&
                        item.extension !== "" &&
                        item.extension && (
                          <MenuItem key={item.extension} value={item.extension}>
                            {item.name}
                          </MenuItem>
                        )
                    )}
                  {state.contacts.length === 0 && (
                    <Box textAlign="center">
                      <Typography
                        fontWeight="bold"
                        fontStyle="italic"
                        variant="body1"
                      >
                        No Data
                      </Typography>
                    </Box>
                  )}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                size="large"
                sx={{ height: 39 }}
                onClick={handlefor}
              >
                forward
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Dialog>
    );
  }
  return (
    <>
      <Dialog
        open={data.state === "ringing" && data.toForward === false}
        fullWidth={true}
        maxWidth="sm"
        PaperComponent={DraggableContent}
        hideBackdrop
      >
        <Box sx={{ pb: "10px" }}>
          {/* <Grid container spacing={2} alignItems="center"> */}
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            sx={{ padding: "12px" }}
          >
            <Grid
              container
              item
              xs={5}
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              {memberInfo?.status === false ? (
                <Grid direction="column" alignItems="center">
                  <Avatar
                    sx={{
                      mt: 3,
                      bgcolor: "#0B557B",
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      border: "10px solid #D2E2EA",
                      boxShadow: "0 0 0px 10px #EAF8FF",
                    }}
                  >
                    {"UN"}
                  </Avatar>
                  <Grid
                    direction="column"
                    sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                  >
                    <Typography>Unknown User </Typography>
                  </Grid>
                  {memberInfo.contacts &&
                    memberInfo.contacts.map((item) => (
                      <Grid
                        key={item.id}
                        container
                        direction="column"
                        alignItems="center"
                      >
                        <Typography
                          sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              display: "inline",
                              mb: 2,
                            }}
                          >
                            {item?.first_name} {item?.last_name}
                          </Typography>
                          <Typography sx={{ fontSize: "12px" }}>
                            {memberInfo.status ? (
                              <span
                                style={{
                                  color:
                                    memberInfo.status === "ACTIVE"
                                      ? "green"
                                      : "red",
                                  padding: "2px 4px",
                                  fontWeight: "bold",
                                }}
                              >
                                ({memberInfo.status})
                              </span>
                            ) : (
                              <span></span>
                            )}
                          </Typography>
                        </Typography>
                      </Grid>
                    ))}
                </Grid>
              ) : (
                memberInfo?.contacts &&
                memberInfo?.contacts.map((item) => (
                  <Grid key={item.id} container direction="column" alignItems="center">
                    <Typography
                      sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline", mb: 2 }}
                      >
                        <Avatar
                          sx={{
                            mt: 3,
                            bgcolor: "#0B557B",
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            border: "10px solid #D2E2EA",
                            boxShadow: "0 0 0px 10px #EAF8FF",
                          }}
                        >
                          {item?.first_name.charAt(0).toUpperCase() +
                            item?.last_name.charAt(0).toUpperCase()}
                        </Avatar>
                        <Grid
                          direction="column"
                          sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                        >
                          <Typography>
                            {item?.first_name} {item?.last_name}{" "}
                          </Typography>
                        </Grid>
                      </Typography>
                      <Typography sx={{ fontSize: "12px" }}>
                        {memberInfo.status ? (
                          <span
                            style={{
                              color:
                                memberInfo.status === "ACTIVE"
                                  ? "green"
                                  : "red",
                              padding: "2px 4px",
                              fontWeight: "bold",
                            }}
                          >
                            ({memberInfo.status})
                          </span>
                        ) : (
                          <span></span>
                        )}
                      </Typography>
                    </Typography>
                  </Grid>
                ))
              )}
            </Grid>
            <Grid container item xs={7} justifyContent="center">
              <Box sx={{ flexDirection: "row" }}>
                <Box sx={{ m: 0 }}>
                  <Typography
                    className={classes.tyIncoming}
                    //sx={{ fontSize: '26px', color: "#346077", mb: "-1rem" }}
                  >
                    Incoming Call
                    {/* <Button onClick={() => setCallData({ toForward: true })}>
                                            <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="65" height="65" rx="32.5" fill="#FFE49F" />
                                                <path d="M34.9607 26.8876H39.5609L38.5458 27.9197C38.3065 28.1614 38.1721 28.4883 38.1721 28.8291C38.1721 29.17 38.3065 29.4969 38.5458 29.7386C38.7865 29.9789 39.1122 30.1138 39.4517 30.1138C39.7912 30.1138 40.1168 29.9789 40.3576 29.7386L43.57 26.5135C43.8093 26.2718 43.9437 25.9448 43.9437 25.604C43.9437 25.2632 43.8093 24.9362 43.57 24.6945L40.3576 21.4694C40.1118 21.258 39.7956 21.1476 39.4722 21.1601C39.1488 21.1727 38.842 21.3073 38.6132 21.537C38.3843 21.7668 38.2503 22.0748 38.2378 22.3994C38.2253 22.7241 38.3353 23.0416 38.5458 23.2884L39.5609 24.3075H34.9607C34.6199 24.3075 34.2931 24.4434 34.0521 24.6853C33.8111 24.9273 33.6758 25.2554 33.6758 25.5976C33.6758 25.9397 33.8111 26.2678 34.0521 26.5098C34.2931 26.7517 34.6199 26.8876 34.9607 26.8876ZM40.7431 35.1956C40.4604 35.1956 40.1649 35.1053 39.8822 35.0408C39.3097 34.9141 38.7471 34.746 38.1988 34.5376C37.6027 34.3199 36.9475 34.3312 36.3592 34.5694C35.7709 34.8075 35.2911 35.2557 35.0121 35.8277L34.7294 36.4082C33.4779 35.7092 32.3278 34.8411 31.3114 33.8281C30.3024 32.8077 29.4377 31.6531 28.7415 30.3966L29.2812 30.0353C29.8509 29.7553 30.2973 29.2736 30.5345 28.683C30.7717 28.0923 30.783 27.4345 30.5661 26.836C30.3621 26.2844 30.1947 25.7198 30.065 25.146C30.0007 24.8622 29.9493 24.5655 29.9108 24.2688C29.7548 23.3601 29.2807 22.5372 28.5739 21.9483C27.8672 21.3594 26.9742 21.0432 26.0559 21.0566H22.201C21.6472 21.0513 21.0988 21.166 20.5931 21.3927C20.0874 21.6193 19.6363 21.9528 19.2705 22.3702C18.9047 22.7876 18.6328 23.2793 18.4733 23.8117C18.3137 24.3442 18.2704 24.9049 18.3461 25.4556C19.0306 30.8602 21.4891 35.8817 25.3333 39.7271C29.1774 43.5724 34.1881 46.0224 39.5738 46.69H40.0621C41.0096 46.6913 41.9245 46.3423 42.632 45.7095C43.0385 45.3445 43.3632 44.897 43.5848 44.3966C43.8063 43.8963 43.9195 43.3544 43.917 42.8069V38.9367C43.9012 38.0406 43.5762 37.1778 42.9974 36.4955C42.4185 35.8132 41.6218 35.3538 40.7431 35.1956ZM41.3856 42.9359C41.3853 43.1191 41.3463 43.3001 41.2709 43.4669C41.1956 43.6337 41.0857 43.7825 40.9487 43.9034C40.8051 44.0279 40.6372 44.1209 40.4558 44.1764C40.2743 44.2319 40.0833 44.2488 39.895 44.2259C35.0827 43.6065 30.6127 41.3962 27.1901 37.9438C23.7676 34.4913 21.5873 29.9932 20.9931 25.1589C20.9727 24.97 20.9906 24.7788 21.0458 24.597C21.101 24.4152 21.1924 24.2465 21.3143 24.1011C21.4348 23.9635 21.583 23.8532 21.7492 23.7776C21.9153 23.7019 22.0956 23.6627 22.2781 23.6625H26.133C26.4318 23.6558 26.7236 23.7539 26.9581 23.9399C27.1927 24.1259 27.3553 24.3882 27.418 24.6816C27.4694 25.0342 27.5336 25.3825 27.6107 25.7266C27.7591 26.4066 27.9567 27.0749 28.2018 27.7261L26.4028 28.5647C26.249 28.6355 26.1107 28.7362 25.9957 28.8609C25.8807 28.9856 25.7914 29.1318 25.7329 29.2912C25.6744 29.4507 25.6479 29.6201 25.6548 29.7899C25.6617 29.9596 25.7019 30.1264 25.7732 30.2805C27.6225 34.2574 30.8067 37.4542 34.768 39.3108C35.0808 39.4399 35.4317 39.4399 35.7446 39.3108C35.9048 39.2533 36.0521 39.1644 36.1778 39.0492C36.3035 38.934 36.4052 38.795 36.477 38.64L37.2737 36.8339C37.938 37.0724 38.6159 37.2706 39.3039 37.4274C39.6466 37.5048 39.9935 37.5693 40.3447 37.6209C40.637 37.6838 40.8982 37.8471 41.0835 38.0825C41.2688 38.318 41.3665 38.6109 41.3599 38.9109L41.3856 42.9359Z" fill="#FFA552" />
                                            </svg>
                                        </Button> */}
                  </Typography>
                  <path
                    d="M34.9607 26.8876H39.5609L38.5458 27.9197C38.3065 28.1614 38.1721 28.4883 38.1721 28.8291C38.1721 29.17 38.3065 29.4969 38.5458 29.7386C38.7865 29.9789 39.1122 30.1138 39.4517 30.1138C39.7912 30.1138 40.1168 29.9789 40.3576 29.7386L43.57 26.5135C43.8093 26.2718 43.9437 25.9448 43.9437 25.604C43.9437 25.2632 43.8093 24.9362 43.57 24.6945L40.3576 21.4694C40.1118 21.258 39.7956 21.1476 39.4722 21.1601C39.1488 21.1727 38.842 21.3073 38.6132 21.537C38.3843 21.7668 38.2503 22.0748 38.2378 22.3994C38.2253 22.7241 38.3353 23.0416 38.5458 23.2884L39.5609 24.3075H34.9607C34.6199 24.3075 34.2931 24.4434 34.0521 24.6853C33.8111 24.9273 33.6758 25.2554 33.6758 25.5976C33.6758 25.9397 33.8111 26.2678 34.0521 26.5098C34.2931 26.7517 34.6199 26.8876 34.9607 26.8876ZM40.7431 35.1956C40.4604 35.1956 40.1649 35.1053 39.8822 35.0408C39.3097 34.9141 38.7471 34.746 38.1988 34.5376C37.6027 34.3199 36.9475 34.3312 36.3592 34.5694C35.7709 34.8075 35.2911 35.2557 35.0121 35.8277L34.7294 36.4082C33.4779 35.7092 32.3278 34.8411 31.3114 33.8281C30.3024 32.8077 29.4377 31.6531 28.7415 30.3966L29.2812 30.0353C29.8509 29.7553 30.2973 29.2736 30.5345 28.683C30.7717 28.0923 30.783 27.4345 30.5661 26.836C30.3621 26.2844 30.1947 25.7198 30.065 25.146C30.0007 24.8622 29.9493 24.5655 29.9108 24.2688C29.7548 23.3601 29.2807 22.5372 28.5739 21.9483C27.8672 21.3594 26.9742 21.0432 26.0559 21.0566H22.201C21.6472 21.0513 21.0988 21.166 20.5931 21.3927C20.0874 21.6193 19.6363 21.9528 19.2705 22.3702C18.9047 22.7876 18.6328 23.2793 18.4733 23.8117C18.3137 24.3442 18.2704 24.9049 18.3461 25.4556C19.0306 30.8602 21.4891 35.8817 25.3333 39.7271C29.1774 43.5724 34.1881 46.0224 39.5738 46.69H40.0621C41.0096 46.6913 41.9245 46.3423 42.632 45.7095C43.0385 45.3445 43.3632 44.897 43.5848 44.3966C43.8063 43.8963 43.9195 43.3544 43.917 42.8069V38.9367C43.9012 38.0406 43.5762 37.1778 42.9974 36.4955C42.4185 35.8132 41.6218 35.3538 40.7431 35.1956ZM41.3856 42.9359C41.3853 43.1191 41.3463 43.3001 41.2709 43.4669C41.1956 43.6337 41.0857 43.7825 40.9487 43.9034C40.8051 44.0279 40.6372 44.1209 40.4558 44.1764C40.2743 44.2319 40.0833 44.2488 39.895 44.2259C35.0827 43.6065 30.6127 41.3962 27.1901 37.9438C23.7676 34.4913 21.5873 29.9932 20.9931 25.1589C20.9727 24.97 20.9906 24.7788 21.0458 24.597C21.101 24.4152 21.1924 24.2465 21.3143 24.1011C21.4348 23.9635 21.583 23.8532 21.7492 23.7776C21.9153 23.7019 22.0956 23.6627 22.2781 23.6625H26.133C26.4318 23.6558 26.7236 23.7539 26.9581 23.9399C27.1927 24.1259 27.3553 24.3882 27.418 24.6816C27.4694 25.0342 27.5336 25.3825 27.6107 25.7266C27.7591 26.4066 27.9567 27.0749 28.2018 27.7261L26.4028 28.5647C26.249 28.6355 26.1107 28.7362 25.9957 28.8609C25.8807 28.9856 25.7914 29.1318 25.7329 29.2912C25.6744 29.4507 25.6479 29.6201 25.6548 29.7899C25.6617 29.9596 25.7019 30.1264 25.7732 30.2805C27.6225 34.2574 30.8067 37.4542 34.768 39.3108C35.0808 39.4399 35.4317 39.4399 35.7446 39.3108C35.9048 39.2533 36.0521 39.1644 36.1778 39.0492C36.3035 38.934 36.4052 38.795 36.477 38.64L37.2737 36.8339C37.938 37.0724 38.6159 37.2706 39.3039 37.4274C39.6466 37.5048 39.9935 37.5693 40.3447 37.6209C40.637 37.6838 40.8982 37.8471 41.0835 38.0825C41.2688 38.318 41.3665 38.6109 41.3599 38.9109L41.3856 42.9359Z"
                    fill="#FFA552"
                  />

                  <Typography className={classes.tyDuration}>
                    Status:
                    <span className={classes.tySpan}>Connecting...</span>
                  </Typography>
                </Box>
                <Box component="div">
                  <Grid container sx={{ mt: 1, fontSize: "10px" }}>
                    <Typography
                      sx={{
                        display: "flex",
                        gap: "10px",
                        mb: "8px",
                        mt: "14px",
                      }}
                    >
                      {" "}
                      {memberInfo &&
                        memberInfo?.mailing_address &&
                        memberInfo?.mailing_address?.address}{" "}
                      {memberInfo?.mailing_address?.zip}{" "}
                    </Typography>
                  </Grid>
                  {memberInfo &&
                    memberInfo?.task_jobs &&
                    memberInfo?.task_jobs?.map((items) => {
                      return (
                        <>
                          <Grid
                            direction="column"
                            sx={{ mt: 1, fontSize: "10px" }}
                          >
                            <Typography
                              sx={{ mb: "10px", display: "flex", gap: "10px" }}
                            >
                              <b>Recent Job :</b> {items?.title}{" "}
                            </Typography>
                          </Grid>
                        </>
                      );
                    })}
                </Box>
                <Box sx={{ mt: 3 }}>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{ color: "#fff" }}
                    className={classes.ButtonAnswer}
                    // onClick={() => answer()}
                    onClick={handleClick}
                  >
                    <Box
                      component="span"
                      sx={{ mr: 2, mt: 1 }}
                      className={classes.cstmbox}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M13 5C13.5304 5 14.0391 5.21071 14.4142 5.58579C14.7893 5.96086 15 6.46957 15 7M13 1C14.5913 1 16.1174 1.63214 17.2426 2.75736C18.3679 3.88258 19 5.4087 19 7M3 2H7L9 7L6.5 8.5C7.57096 10.6715 9.32847 12.429 11.5 13.5L13 11L18 13V17C18 17.5304 17.7893 18.0391 17.4142 18.4142C17.0391 18.7893 16.5304 19 16 19C12.0993 18.763 8.42015 17.1065 5.65683 14.3432C2.8935 11.5798 1.23705 7.90074 1 4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2Z"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Box>
                    Accept
                  </Button>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{ ml: 2, mt: 3, color: "#fff" }}
                    className={classes.ButtonVoicemail}
                    onClick={() => ToVoiceMail()}
                  >
                    <Box
                      component="span"
                      sx={{ mr: 2, mt: 1 }}
                      className={classes.cstmboxs}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.736 1.22692C5.722 -0.206077 3.694 -0.448077 2.468 0.842923L0.898001 2.49492C0.362001 3.05992 -0.0449987 3.84292 0.00400125 4.75692C0.104001 6.60692 0.888001 10.3909 5.022 14.7419C9.451 19.4059 13.676 19.6399 15.5 19.4599C16.247 19.3869 16.852 18.9879 17.295 18.5209L18.715 17.0259C20.02 15.6519 19.64 13.3529 18.008 12.4129L16.097 11.3129C14.998 10.6809 13.637 10.8619 12.762 11.7819L12.354 12.2119C12.258 12.2383 12.1571 12.2407 12.06 12.2189C11.658 12.1529 10.79 11.7979 9.357 10.2899C7.929 8.78692 7.577 7.86092 7.511 7.40592C7.479 7.18592 7.511 7.06992 7.524 7.03392L7.527 7.02792L7.771 6.76992C8.739 5.75192 8.807 4.15792 7.997 3.00992L6.736 1.22692ZM3.556 1.87592C4.078 1.32592 4.999 1.36892 5.511 2.09292L6.771 3.87692C7.194 4.47392 7.129 5.26792 6.684 5.73692L6.397 6.03892L6.929 6.54392C6.7537 6.37377 6.57601 6.20609 6.396 6.04092L6.394 6.04192L6.391 6.04492L6.385 6.05192L6.372 6.06692C6.33341 6.11054 6.29862 6.15738 6.268 6.20692C6.216 6.28792 6.159 6.39692 6.111 6.53092C6.013 6.80592 5.961 7.16892 6.027 7.62292C6.157 8.51592 6.742 9.71492 8.269 11.3229C9.792 12.9269 10.942 13.5569 11.819 13.6989C12.27 13.7719 12.635 13.7139 12.911 13.6049C13.064 13.5446 13.2062 13.4598 13.332 13.3539L13.368 13.3209L13.382 13.3069L13.389 13.3009L13.392 13.2969L13.393 13.2959C13.393 13.2959 13.395 13.2939 12.867 12.7939L13.395 13.2939L13.85 12.8149C14.235 12.4089 14.836 12.3179 15.349 12.6129L17.259 13.7129C18.08 14.1849 18.241 15.3469 17.628 15.9929L16.208 17.4879C15.928 17.7819 15.636 17.9399 15.353 17.9679C13.918 18.1089 10.173 17.9879 6.109 13.7089C2.233 9.62892 1.583 6.18592 1.502 4.67692C1.48 4.27692 1.654 3.87692 1.986 3.52792L3.556 1.87592Z"
                          fill="white"
                        />
                        <path
                          d="M14.28 1.22082C14.1378 1.08834 13.9497 1.01622 13.7554 1.01965C13.5611 1.02308 13.3758 1.10179 13.2383 1.2392C13.1009 1.37661 13.0222 1.562 13.0188 1.7563C13.0154 1.9506 13.0875 2.13865 13.22 2.28082L14.69 3.75082L13.22 5.22082C13.1463 5.28948 13.0872 5.37229 13.0462 5.46428C13.0052 5.55628 12.9832 5.6556 12.9814 5.7563C12.9796 5.857 12.9981 5.95703 13.0358 6.05042C13.0736 6.14381 13.1297 6.22864 13.2009 6.29986C13.2722 6.37108 13.357 6.42722 13.4504 6.46495C13.5438 6.50267 13.6438 6.52119 13.7445 6.51941C13.8452 6.51764 13.9445 6.4956 14.0365 6.4546C14.1285 6.41361 14.2113 6.35451 14.28 6.28082L15.75 4.81082L17.22 6.28082C17.2886 6.35451 17.3714 6.41361 17.4634 6.4546C17.5554 6.4956 17.6547 6.51764 17.7554 6.51941C17.8562 6.52119 17.9562 6.50267 18.0496 6.46495C18.143 6.42722 18.2278 6.37108 18.299 6.29986C18.3702 6.22864 18.4264 6.14381 18.4641 6.05042C18.5018 5.95703 18.5203 5.857 18.5186 5.7563C18.5168 5.6556 18.4947 5.55628 18.4538 5.46428C18.4128 5.37229 18.3537 5.28948 18.28 5.22082L16.81 3.75082L18.28 2.28082C18.4125 2.13865 18.4846 1.9506 18.4811 1.7563C18.4777 1.562 18.399 1.37661 18.2616 1.2392C18.1242 1.10179 17.9388 1.02308 17.7445 1.01965C17.5502 1.01622 17.3621 1.08834 17.22 1.22082L15.75 2.69082L14.28 1.22082Z"
                          fill="white"
                        />
                      </svg>
                    </Box>
                    To Voicemail
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </>
  );
};

CallPending.defaultProps = {
  phone_no: "266-555-1212",
  contact: "Unknown",
  isUnknown: true,
};

export default React.memo(CallPending);
